import { UseAdSpend, UseAdSpendOptions } from '../../../hooks/useAdSpend';
import { useCampaign } from './useCampaign';
import { useCampaignParameters } from '@features/campaigns';

const useAdSpend = (
  options: Pick<UseAdSpendOptions, 'campaignId'>
): UseAdSpend => {
  const { campaignId } = options;
  const { campaign, isFetching } = useCampaign({ id: campaignId });
  return {
    adSpend: campaign?.adSpend ?? null,
    isFetching,
  };
};

export const useCurrentAdSpend = (): UseAdSpend => {
  const { id } = useCampaignParameters();
  return useAdSpend({ campaignId: Number(id) });
};
